package com.tixforgigs.common.core.extensions


import com.tixforgigs.common.core.enums.CurrencyLegacy
import com.tixforgigs.apax.models.Amount
import kotlin.math.absoluteValue

// todo(PROTO-655) -> better currency handling
fun Amount.toPriceString(): String {
  return "${value.toFormattedPriceString()} ${
    CurrencyLegacy.from(
      currency.value
    )?.value ?: currency.value
  }"
}

fun Amount.minus(amount: Amount): Amount? {
  return if (currency != amount.currency) null
  else {
    Amount(
      value = value - amount.value,
      currency = currency
    )
  }
}

fun Amount.plus(amount: Amount): Amount? {
  return if (currency != amount.currency) null
  else {
    Amount(
      value = value + amount.value,
      currency = currency
    )
  }
}

fun Amount.times(quantity: Int): Amount {
  return Amount(
    value = value * quantity,
    currency = currency
  )
}

fun Int.toFormattedPrice(): String {
  val sign = if (this < 0) "-" else ""
  val euros = absoluteValue / 100
  val cents = absoluteValue % 100

  val eurosStr = euros
    .toString()
    .reversed()
    .chunked(3)
    .joinToString(".")
    .reversed()

  val centsStr = cents.toString().padStart(2, '0')

  return "$sign$eurosStr,$centsStr €"
}

